import { BootCampItemGroq, bootcampOverviewModuleGroq } from '~/types/bootcamp'

export default function getSubjectsWithCoursesList(
  localSubjects: BootCampItemGroq[],
  enSubjects: BootCampItemGroq[],
): BootCampItemGroq[] {
  let newSubjectsCoursesModule: BootCampItemGroq[] = []

  enSubjects.forEach((enSubItem) => {
    const localSubItem = localSubjects.find((sub) => sub.key === enSubItem.key)
    if (!localSubItem) {
      newSubjectsCoursesModule = [...newSubjectsCoursesModule, { ...enSubItem, isUpcoming: true }]
    } else {
      const localSubCourseModule = localSubItem.courses?.modules
      const enSubCourseModule = enSubItem.courses?.modules
      if (localSubCourseModule?.length === enSubCourseModule?.length) {
        newSubjectsCoursesModule = [...newSubjectsCoursesModule, localSubItem]
      } else {
        let newCourses: bootcampOverviewModuleGroq[] = []
        enSubCourseModule?.forEach((enSubCourseItem) => {
          const localSubCourseItem = localSubCourseModule?.find(
            (course) => course.moduleNumber === enSubCourseItem.moduleNumber,
          )
          if (!localSubCourseItem) {
            newCourses = [...newCourses, { ...enSubCourseItem, isUpcoming: true }]
          } else {
            newCourses = [...newCourses, localSubCourseItem]
          }
        })

        const data = { ...localSubItem, courses: { modules: newCourses } } as BootCampItemGroq
        newSubjectsCoursesModule = [...newSubjectsCoursesModule, data]
      }
    }
  })

  return newSubjectsCoursesModule || []
}
